import categories from "~/assets/js/Helpers/categories";

const headerMenuLinks = {
    topMenu: reactConfig.headMenu,
    bottomMenu: categories,
};

export default headerMenuLinks;
